import {DatePicker} from "formik-material-ui-pickers";
import React from "react";

export default ({...props}) => (
  <DatePicker
    {...props}
    format="dd/MM/yyyy"
    fullWidth
  />
)